export default function Settings () {
    return(
        <div>
            Settings pages
        </div>
    )
}